
export interface HistoricalInsertGuard {
  canApply(): boolean;
  rows: Array<{ table: string; id: string; expected: Record<string, unknown> | null }>;
  tables: Array<{ table: string; expected: Record<string, unknown>[] }>;
}

const same = (left: unknown, right: unknown): boolean => {
  if (left === right) return true;
  if (left == null || right == null || typeof left !== 'object' || typeof right !== 'object') return false;
  if (Array.isArray(left) !== Array.isArray(right)) return false;
  const a = left as Record<string, unknown>;
  const b = right as Record<string, unknown>;
  const keys = Object.keys(a);
  return keys.length === Object.keys(b).length && keys.every(key =>
    Object.prototype.hasOwnProperty.call(b, key) && same(a[key], b[key]));
};
const ordered = (rows: Record<string, unknown>[]) => [...rows].sort((a, b) => String(a.id).localeCompare(String(b.id)));

/** Executada dentro da transação de inserção para fechar corridas de fila, delete e identidade. */
export const historicalInsertGuardMatches = async (
  guard: HistoricalInsertGuard,
  read: (table: string, id: string) => Promise<Record<string, unknown> | null>,
  list: (table: string) => Promise<Record<string, unknown>[]>,
): Promise<boolean> => {
  if (!guard.canApply()) return false;
  for (const row of guard.rows) {
    if (!same(await read(row.table, row.id), row.expected)) return false;
  }
  for (const table of guard.tables) {
    if (!same(ordered(await list(table.table)), ordered(table.expected))) return false;
  }
  return guard.canApply();
};
